<template>
    <div id="loading" ref="loading"
         v-show="this.$root.current_event_is_loaded.length > 0 || this.$root.has_call_ajax.length > 0">
        <div class="loading-content">
            <div class="loading-message">
                <div>{{ this.trans.get('kiosk.loading-wait') }}</div>
                <div ref="loading_message">{{ this.$root.current_loading_message }}</div>
            </div>
            <div><img src="/assets/kiosk/img/loading.svg"></div>
            <div class="loading-message-tip" ref="loading_message_tip">{{ this.trans.get('kiosk.loading-tip') }}</div>
            <div class="mt-5">
                <button @click="this.$root.cancel(); this.disable_cancel_btn();" v-bind:disabled="this.$root.global_cancel_btn_disabled" type="button" class="btn btn-light-primary text-uppercase">
                    {{ this.trans.get('buttons.cancel') }}
                </button>
            </div>
            <div class="mt-5" style="color: #fff">
                Si le chargement persiste plus d'une minute vous pouvez relancer la borne.
            </div>
            <div class="mt-5">
                <button @click="this.$root.reload_borne();" type="button" class="btn btn-light-primary text-uppercase">
                    Relancer la borne
                </button>
            </div>
        </div>
    </div>
    <div id="errors" v-show="this.$root.errors.length > 0" >
        <div class="errors-content">
            <div class="errors-title">
                <div class="errors-title-icon"><i class="far fa-exclamation-circle"></i></div>
                {{ this.trans.get('kiosk.error-title') }}
            </div>
            <div v-for="error in this.$root.errors" class="errors-message">Code: {{ error.code }}</div>
            <div class="errors-close">
                <button type="button" @click="this.$root.removeErrors()" class="btn-error">{{ this.trans.get('kiosk.close') }} <i class="far fa-times"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from "vue";

export default defineComponent({

    name: "LoadingAndErrors",

    data() {
        return {
        }
    },

    mounted() {

    },
    methods: {
        disable_cancel_btn(){
          this.$root.global_cancel_btn_disabled = true;
        },
    }

})
</script>

